export default "__VITE_ASSET__rT$1LAj$__"